import React, { useState, useEffect, useCallback } from 'react';
import { getContextTournament, setContextTournament } from '../contextTournament';
import { useSession } from '../SessionContext';

function useContextTournament() {

    const [tournament, setTournament] = useState(getContextTournament());
    const [tournamentId, setTournamentId] = useState(null);
    const [associationCode, setAssociationCode] = useState(null);
    const [liabilityReleaseFileName, setLiabilityReleaseFileName] = useState(null);
    const { sessionData, updateSessionData } = useSession();

    function reloadContextTournament() {
        updateSessionData("contextTournament");
        //sessionStorage.removeItem('contextTournament');
        const contextTournament = getContextTournament();
        setTournament(contextTournament);
        updateSessionData('contextTournament', contextTournament);
    }
    function loadContextTournament(tournamentCode) {
        updateSessionData("contextTournament");
        //sessionStorage.removeItem('contextTournament');
        const contextTournament = setContextTournament(tournamentCode);
        setTournament(contextTournament);
        updateSessionData('contextTournament', contextTournament);
        return contextTournament;
    }
    function getAssociationCode() {
        //const contextTournament = getContextTournament();
        return sessionData?.contextTournament?.association_cd;
    }
    function getTournamentId() {
        //const contextTournament = getContextTournament();
        return sessionData?.contextTournament?.tournament_id;
    }
    function getLiabilityReleaseFileName() {
        //const contextTournament = getContextTournament();
        return sessionData?.contextTournament?.liability_release_filename;
    }

    useEffect(() => {
        setTournamentId(getTournamentId());
        setAssociationCode(getAssociationCode());
        setLiabilityReleaseFileName(getLiabilityReleaseFileName());
    }, [sessionData]);


    return {
        contextTournament: tournament,
        tournamentId,
        associationCode,
        liabilityReleaseFileName,
        reloadContextTournament,
        loadContextTournament,
        getAssociationCode,
        getTournamentId,
        getLiabilityReleaseFileName
    };
}
export default useContextTournament;